module.exports = __webpack_public_path__ + "img/main_section_img3.7b576ad5.png";